import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchCategories } from 'entities/Category';
import { getSelectedPropertyCatalogId } from 'entities/Property/model/selectors/PropertySelectors';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

export const OrderAddItemPageCatalog = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();

    const isActive = useSelector(getSearchCatalogItemIsActive);
    const selectedPropertyCatalogId = useSelector(getSelectedPropertyCatalogId);

    const catalogId =
        location.state?.selectedPropertyCatalogId || selectedPropertyCatalogId;

    useEffect(() => {
        if (catalogId) {
            dispatch(fetchCategories(catalogId));
        }
    }, [catalogId, dispatch]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                height: '100%',
            }}
        >
            <Box
                sx={
                    isActive
                        ? {
                              display: 'flex',
                              flexDirection: 'column',
                              flex: 1,
                              minHeight: 0,
                          }
                        : undefined
                }
            >
                <SearchCatalogItems
                    catalogId={catalogId}
                    moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    expandable
                    hideField
                />
            </Box>

            {!isActive ? (
                <Box
                    sx={{
                        display: 'flex',
                        borderRadius: '12px 12px 0 0',
                        overflow: 'hidden',
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    <PropertyCatalog
                        isEditing
                        moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
